export default {
    OrderRuless: {
        Doc: '单号',
        number: '客户订单号/内部订单号',
        Channel: '渠道',
        Store: '店铺',
        Sourcing: '寻源状态',
        Order: '下单时间',
        Start: '开始日期',
        End: '结束日期',
        Specify: '指定发货',
        Re: '重新寻源',
        form: {
            Third: '客户订单号',
            Internal: '内部订单号',
            Doc: '寻源单号',
            status: '寻源状态',
            Product: '商品行数量',
            succeeded: '寻源成功',
            failed: '寻源失败',
            reason: '失败原因',
            store: '销售店铺',
            channel: '销售渠道',
            ordering: '三方下单时间',
            time: '支付时间',
            creation: '寻源创建时间',
            Please: '请选择状态为 寻源失败 或 部分寻源 的寻源单执行重新寻源操作',
            sure: '您确定要重新寻源吗 ?',
            Canceled: '已取消',
            Shipment: '寻源失败才能指定发货',
            want: '您确定要取消该订单的寻源吗 ?',
            Cancellation: '取消成功 !',
        }
    }
};
